<template>
  <section class="content-meta form-section__container">
    <div v-if="name" class="meta-header" data-testid="form-section__header">
      <h3 v-if="href && name">
        <a :href="href" data-testid="form-section__href">{{ name }}</a>
      </h3>
      <h3 v-else>{{ name }}</h3>
    </div>
    <div :class="bodyCssClasses">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'FormSection',
  props: {
    name: { required: false, type: String },
    href: { required: false, type: String },
    bodyClass: { required: false, type: String },
    childrenCount: { type: Number, default: null },
  },
  data() {
    return { amountChildren: null }
  },
  computed: {
    bodyCssClasses() {
      const base = ['meta-body', 'form-section__body', '-flex']
      const fromProps = this.bodyClass ? this.bodyClass?.split(' ') : []
      const width = this.amountChildren > 0 ? `form-section__${Math.floor(100 / this.amountChildren)}` : ''
      return [...base, ...fromProps, width].join(' ')
    },
  },
  methods: {
    setAmountChildren() {
      if (this.childrenCount) this.amountChildren = this.childrenCount
      else if (this._isMounted && this.$slots.default) {
        // vue-test utils does not handle slots and mounted() very well..
        this.amountChildren = this.$slots.default.length
      } else {
        this.amountChildren = this.$children.length
      }
    },
  },
  mounted() {
    this.setAmountChildren()
  },
}
</script>

<style lang="scss">
.form-section {
  &__container {
    flex-grow: 1;
  }
  &__body.-flex {
    display: flex;
    gap: 1rem;
  }
  &__100 > div {
    width: 100%;
  }
  &__50 > div {
    width: 50%;
  }
  &__33 > div {
    width: calc(100% / 3);
  }
  &__25 > div {
    width: 25%;
  }
}
</style>
